export const AMOUNT_LINKS_TO_RENDER_EXCEPTION = 4;